export default "__VITE_ASSET__CZ_pKSX9__"